<template>
    <div class="ah-page qr-code-uploader">
        <div v-if="!isSubmit" class="ah-container">
            <div class="block">
                <ahUploader ref="ahUploader" ui no-upload rotate-btn accept="image/png, image/jpeg" @change="onChangeAttachment" />
            </div>
            <div class="button-block">
                <el-button :loading="isLoading" :disabled="!formData" @click="onSubmit" class="submit-btn" :type="formData !== null ? 'primary' : ''">確認</el-button>
            </div>
            <div class="block">
                <div style="font-size: 12px; color: #aaa; margin-top: 10px">(檔案大小上限：25MB)</div>
            </div>
        </div>
        <div v-else class="ah-container">
            <div class="finish-msg">
                <div><i class="el-icon-check finish-icon"></i></div>
                <span>您已上傳，請回到電腦上繼續作業！</span>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import ahUploader from '@/components/ui/Uploader/ahUploader.vue';

export default {
    components: { ahUploader },
    data() {
        return {
            formData: null,
            meta: null,
            isLoading: false,
            isSubmit: false,
        };
    },
    computed: {
        key() {
            return this.$route.query.key;
        },
        mno() {
            return Number(this.$route.query.mno);
        },
    },
    methods: {
        onUploadFile() {
            this.$refs.ahUploader.onUploadFile();
        },
        onChangeAttachment(data) {
            this.formData = data.formData;
            this.meta = {
                foo: data.foo,
                foO_DAT: data.foO_DAT,
                filE_TYP: data.filE_TYP,
                bsn: data.bsn,
                buyerBsn: data.buyerBsn,
                amt: data.amt,
                tax: data.tax,
                fileInfo: data.fileInfo,
            };
        },
        async onSubmit() {
            if (!this.formData) {
                this.$message({
                    showClose: true,
                    message: '請先上傳圖片',
                    type: 'error',
                });
                return;
            }
            try {
                this.isLoading = true;

                this.formData.append('key', this.key);
                this.formData.append('mno', this.mno);
                this.formData.append('meta', JSON.stringify(this.meta));
                await axios.post(`${process.env.VUE_APP_API_PATH}Tool/UploadFromExternal`, this.formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                        // Authorization: `Bearer ${localStorage.getItem('token')}`,
                    },
                });
                this.isSubmit = true;
            } catch (e) {
                console.log(e.response);
                this.$message({
                    showClose: true,
                    message: e.response.data,
                    type: 'error',
                });
            } finally {
                this.isLoading = false;
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.qr-code-uploader {
    .submit-btn {
        width: 250px;
        height: 50px;
    }

    .finish-msg {
        margin-top: 20ch;
        text-align: center;

        .finish-icon {
            font-size: 50pt;
            margin-bottom: 30px;
        }
    }
}
.block {
    text-align: center;
}
.button-block {
    text-align: center;
    margin-top: 20px;
}
</style>
